<template>
  <section class="section container pt-0">
    <!-- <pre>{{ orders_summary }}</pre> -->
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          v-bind:class="{ 'is-active': sidx == 0 }"
          v-for="(smry, sidx) in orders_summary"
          :key="sidx"
          :data-tab="smry.status_code"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="icon" aria-hidden="true"></i>
            <span>{{ translate_status(smry.status_code) }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="container is-fluid" ref="contents">
      <div
        v-bind:class="{ 'is-active': sidx == 0, 'is-hidden': sidx != 0 }"
        v-for="(smry, sidx) in orders_summary"
        :key="sidx"
        :data-tab="smry.status_code"
      >
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("product") }}</th>
              <th>{{ $t("summary") }}</th>
              <th>{{ $t("customizations") }}</th>
              <th>{{ $t("options") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in smry.products" :key="product.product">
              <td>{{ product.count }}</td>
              <td>{{ product.product }}</td>
              <td>
                <ul>
                  <li v-for="grade in product.grade_summary" :key="grade.grade">
                    {{ grade.grade }}: {{ grade.count }}
                  </li>
                </ul>
              </td>
              <td>
                <ul>
                  <li
                    v-for="customization in product.customizations"
                    :key="customization"
                  >
                    {{ customization }}
                  </li>
                </ul>
              </td>
              <td>
                <div class="field">
                  <input
                    class="is-checkradio"
                    type="checkbox"
                    :id="'chk_finished_' + product.product"
                    :name="'chk_finished_' + product.product"
                    @change="change_finished(product, $event)"
                  />
                  <label :for="'chk_finished_' + product.product">{{
                    $t("finished")
                  }}</label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <pre>{{ smry.products }}</pre> -->
      </div>
    </div>
  </section>
</template>

<script>
import { get, change_active_tab, post } from "@/utils";
import { groupBy } from "lodash";
import status_catalog from "../status.json";

export default {
  name: "WorkOrderSummary",
  components: {},
  data() {
    return {
      status_catalog: status_catalog,
      orders: [],
    };
  },
  computed: {
    orders_summary() {
      let v = this;
      let grouped_by_status = groupBy(v.orders, "status_code");
      let g = Object.keys(grouped_by_status).map((k) => {
        let gg = groupBy(
          grouped_by_status[k].reduce((acc, wo) => {
            let tailoring_items = wo.work_order_items.reduce((a, woi) => {
              let items = woi.tailoring_order.tailoring_order_items.reduce(
                (b, toi) => {
                  return b.concat({
                    product_name: toi.product.name,
                    product_id: toi.product.product_id,
                    quantity: toi.quantity,
                    customization: toi.customization,
                    customer: woi.tailoring_order.name,
                    source: woi.tailoring_order.source,
                    size: toi.size,
                    grade: woi.tailoring_order.grade,
                    // tailoring_order_id: toi.order_id,
                    // work_order_item_id: woi.item_id,
                    obj: {
                      tailoring_order_id: toi.order_id,
                      work_order_id: woi.order_id,
                      work_order_item_id: woi.item_id,
                    },
                  });
                },
                []
              );
              return a.concat(items);
            }, []);

            return acc.concat(tailoring_items);
          }, []),
          function (item) {
            return `${item.product_name} - ${v.$t(
              "size"
            )} ${item.size.toUpperCase()} / (${item.source})`;
          }
        );

        let arr_gg = Object.keys(gg).map((kk) => {
          let grade_summary = groupBy(gg[kk], "grade");
          let grade_summary_arr = Object.keys(grade_summary).map((grade) => {
            return {
              grade: grade,
              count: grade_summary[grade].reduce((acc, item) => {
                return acc + Number(item.quantity);
              }, 0),
            };
          });

          // console.log("gg[kk]", gg[kk]);

          // let tailoring_order_summary = gg[kk].reduce((acc, item) => {
          //   if (acc.indexOf(item.tailoring_order_id) === -1) {
          //     acc.push(item.tailoring_order_id);
          //   }
          //   return acc;
          // }, []);

          // let work_order_summary = gg[kk].reduce((acc, item) => {
          //   if (acc.indexOf(item.work_order_item_id) === -1) {
          //     acc.push(item.work_order_item_id);
          //   }
          //   return acc;
          // }, []);

          let obj_summary = gg[kk].reduce((acc, item) => {
            console.log("acc", acc);
            let rslt = acc.push(item.obj);
            console.log("item", acc, item, rslt);
            return acc;
            // return acc.push(item.obj);
          }, []);

          return {
            product: kk,
            count: gg[kk].reduce((acc, item) => {
              return acc + Number(item.quantity);
            }, 0),
            customizations: gg[kk]
              .filter((item) => {
                return item.customization;
              })
              .map((item) => {
                return `${item.quantity} x ${item.customization} (${item.customer} / ${item.source})`;
              }),
            grade_summary: grade_summary_arr,
            // tailoring_order_ids: tailoring_order_summary,
            // work_order_item_ids: work_order_summary,
            obj_summary: obj_summary,
            product_id: gg[kk][0].product_id,
            // elements: gg[kk],
          };
        });

        return {
          status_code: k,
          // work_orders: grouped_by_status[k],
          products: arr_gg,
          // products: Object.keys(gg).map((kk) => {
          //   return {
          //     product: kk,
          //     count: gg[kk].reduce((acc, item) => {
          //       return acc + Number(item.quantity);
          //     }, 0),
          //     customizations: gg[kk]
          //       .filter((item) => {
          //         return item.customization;
          //       })
          //       .map((item) => {
          //         return `${item.customization} (${item.customer} / ${item.source})`;
          //       }),
          //   };
          // }),
        };
      });
      return g;
    },
  },
  methods: {
    change_active_tab,
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      let v = this;
      get("/work_order/summary", {})
        .then((response) => {
          v.orders = response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    translate_status(status_code) {
      let v = this;
      let trgt = status_catalog[status_code];
      if (trgt) return v.$t(trgt.text);
      return status_code;
    },
    change_finished(product, $event) {
      let v = this;
      // console.log("change_finished", product);
      post("/work_order/cutting", {
        product_id: product.product_id,
        count: product.count,
        tailoring_order_ids: product.tailoring_order_ids,
        work_order_item_ids: product.work_order_item_ids,
        obj_summary: product.obj_summary,
        finished: $event.target.checked,
      })
        .then(() => {
          v.refresh();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
  created() {},
};
</script>

<style scoped></style>
